import type { ComponentProps } from "react"
import { forwardRef } from "react"

type Props = ComponentProps<"svg">

export const JudgeIcon = forwardRef<SVGSVGElement, Props>((props, ref) => (
	<svg
		width="1em"
		height="1em"
		viewBox="0 0 16 16"
		xmlns="http://www.w3.org/2000/svg"
		ref={ref}
		{...props}
	>
		<path
			fill="currentColor"
			d="M3.19587 5.51233C2.93804 5.76844 2.93427 6.18185 3.18744 6.4357L6.16038 9.41663C6.41355 9.67048 6.8278 9.66865 7.08563 9.41254C7.20945 9.28955 7.27989 9.12317 7.28148 8.95001L7.28743 8.29708C7.28967 8.05219 7.3893 7.8169 7.56439 7.64296L9.65831 5.56301C9.83341 5.38907 10.0696 5.29075 10.315 5.28967L10.9693 5.28678C11.1428 5.28601 11.3098 5.21649 11.4337 5.0935C11.6915 4.83739 11.6953 4.42398 11.4421 4.17013L8.46915 1.1892C8.21597 0.935346 7.80172 0.937175 7.54389 1.19329C7.42008 1.31627 7.34963 1.48265 7.34805 1.65582L7.34209 2.30874C7.33986 2.55364 7.24023 2.78893 7.06513 2.96286L4.97122 5.04282C4.79612 5.21675 4.55989 5.31508 4.3145 5.31616L3.66024 5.31905C3.48672 5.31981 3.31968 5.38934 3.19587 5.51233Z"
		></path>
		<path
			fill="currentColor"
			d="M8.91051 8.22037C8.79362 8.10317 8.79375 7.91343 8.91079 7.79639L9.80256 6.90462C9.91983 6.78735 10.11 6.78748 10.2271 6.90491L10.2969 6.97484C10.4767 7.15514 10.6848 7.30494 10.9133 7.41848L12.7723 8.3423C13.0379 8.47426 13.2798 8.64837 13.4888 8.85791L14.4698 9.84161C15.1859 10.5596 15.1753 11.7289 14.446 12.4533C13.7168 13.1777 12.5451 13.1829 11.829 12.4649L10.8481 11.4813C10.639 11.2717 10.4656 11.0293 10.3346 10.7635L9.41809 8.90394C9.30538 8.67527 9.1562 8.46672 8.97631 8.28634L8.91051 8.22037Z"
		></path>
		<path
			fill="currentColor"
			d="M1.75 13.5C1.33579 13.5 1 13.8358 1 14.25C1 14.6642 1.33579 15 1.75 15H9.25C9.66421 15 10 14.6642 10 14.25C10 13.8358 9.66421 13.5 9.25 13.5H1.75Z"
		></path>
	</svg>
))
